import { render, staticRenderFns } from "./_cCardBase.vue?vue&type=template&id=11680139&scoped=true&"
import script from "./_cCardBase.vue?vue&type=script&lang=ts&"
export * from "./_cCardBase.vue?vue&type=script&lang=ts&"
import style0 from "./_cCardBase.vue?vue&type=style&index=0&id=11680139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11680139",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VRow,VToolbar})
